"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Address = exports.ANON_IDENTITY = void 0;
const base32_decode_1 = __importDefault(require("base32-decode"));
const base32_encode_1 = __importDefault(require("base32-encode"));
const crc_1 = __importDefault(require("crc"));
exports.ANON_IDENTITY = "maa";
class Address {
    constructor(bytes) {
        this.bytes = new Uint8Array(bytes ? bytes : [0x00]);
    }
    static anonymous() {
        return new Address();
    }
    static fromHex(hex) {
        return new Address(Buffer.from(hex, "hex"));
    }
    static fromString(string) {
        if (string === exports.ANON_IDENTITY) {
            return new Address();
        }
        const base32Address = string.slice(1, -2).toUpperCase();
        const base32Checksum = string.slice(-2).toUpperCase();
        const identity = (0, base32_decode_1.default)(base32Address, "RFC4648");
        const checksum = (0, base32_decode_1.default)(base32Checksum, "RFC4648");
        const check = Buffer.allocUnsafe(3);
        check.writeUInt16BE(crc_1.default.crc16(Buffer.from(identity)), 0);
        if (Buffer.compare(Buffer.from(checksum), check.slice(0, 1)) !== 0) {
            throw new Error("Invalid Checksum");
        }
        return new Address(Buffer.from(identity));
    }
    isAnonymous() {
        return Buffer.compare(this.toBuffer(), Buffer.from([0x00])) === 0;
    }
    toBuffer() {
        return Buffer.from(this.bytes);
    }
    toString() {
        if (this.isAnonymous()) {
            return exports.ANON_IDENTITY;
        }
        const identity = this.toBuffer();
        const checksum = Buffer.allocUnsafe(3);
        checksum.writeUInt16BE(crc_1.default.crc16(identity), 0);
        const leader = "m";
        const base32Address = (0, base32_encode_1.default)(identity, "RFC4648", {
            padding: false,
        });
        const base32Checksum = (0, base32_encode_1.default)(checksum, "RFC4648").slice(0, 2);
        return (leader + base32Address + base32Checksum).toLowerCase();
    }
    toHex() {
        if (this.isAnonymous()) {
            return "00";
        }
        return Buffer.from(this.bytes).toString("hex");
    }
    withSubresource(id) {
        let bytes = Buffer.from(this.bytes.slice(0, 29));
        bytes[0] = 0x80 + ((id & 0x7f000000) >> 24);
        const subresourceBytes = Buffer.from([
            (id & 0x00ff0000) >> 16,
            (id & 0x0000ff00) >> 8,
            id & 0x000000ff,
        ]);
        return new Address(Buffer.concat([bytes, subresourceBytes]));
    }
}
exports.Address = Address;
